import { Locale, buildLocaleId } from '../core/locale';
import i18nInstance, { LOCALE_KEY, SUPPORTED_LANGUAGES } from '../../../i18n/i18n.config';
import { delegateLeafLanguage } from './language-delegation';

/**
 * Persiste o locale em localStorage['locale'], troca o idioma ativo do i18next
 * e propaga para o Angular montado (AppModule completo das telas reais e/ou a
 * folha isolada). A leitura compartilhada da chave `locale` só cobre o
 * mount/cold start (hidratação); um Angular já montado não relê o storage em
 * runtime, por isso a delegação explícita abaixo é necessária para refletir a
 * troca imediatamente.
 *
 * Um id fora do conjunto suportado é ignorado silenciosamente: a validação de
 * entrada é responsabilidade de quem oferece as opções na Navbar, não deste
 * efeito, mas o estado persistido/exibido não pode ficar num idioma inválido.
 */
export function applyLanguage(locale: Locale): void {
  const id = buildLocaleId(locale);
  if (!(SUPPORTED_LANGUAGES as readonly string[]).includes(id)) {
    return;
  }
  localStorage.setItem(LOCALE_KEY, id);
  void i18nInstance.changeLanguage(id);
  delegateLeafLanguage(id);
}
